import { Component } from '@angular/core';
import { PortfolioService } from '../portfolio.service';
import { Portfolio } from '../portfolio';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-portfolio-edit',
  templateUrl: 'edit.component.html',
})
export class PortfolioEditComponent {
  /**
   * Details of the portfolio being edited.
   */
  public portfolio: Portfolio;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {PortfolioService} portfolioService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private portfolioService: PortfolioService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.portfolioService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadPortfolio(params.id));
  }

  /**
   * Perform the edit action which send the edited portfolio to the backend.
   */
  public edit() {
    const editPortfolio = this.portfolioService
      .updatePortfolio(this.portfolio.id, this.portfolio)
      .subscribe(
        (result: Portfolio) => {
          this.notificationService.success(
            `Portfolio Updated`,
            `The portfolio ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.portfolio = new Portfolio();
          editPortfolio.unsubscribe();
          this.router.navigate(['/portfolios']);
        },
        err => {
          this.notificationService.error(
            `Portfolio Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/portfolios']);
        },
      );
  }

  /**
   * Loads the requested portfolio so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadPortfolio(id: string) {
    this.portfolioService.findPortfolio(id).subscribe(
      result => {
        this.portfolio = result;
      },
      err => {
        this.notificationService.error(
          `Portfolio Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/portfolios']);
      },
    );
  }
}
